<template>
    <v-app-bar
        color="primary"
        class="shrink">
        <v-app-bar-nav-icon
            color="white"
            @click.native.stop="toggleDrawer()"/>
        <v-toolbar-title
            class="text-xs-center">
          <span class="hidden-md-and-down">
            <span class="white--text">{{ _.get($route, 'meta.title', '???') }}</span>
          </span>
        </v-toolbar-title>
        <v-spacer/>
        <!-- center logo -->
        <img
            :src="$t('app.assets.logo')"
            width="40"
            class="hidden-md-and-up">
        <v-spacer/>
        <v-btn
            v-if="$canAccessRoute('changelog')"
            dark
            icon
            @click="$router.push({name: 'changelog'})">
            <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
        <!--
        <v-menu
            bottom
            left
            offset-y
            transition="slide-y-transition">
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    dark
                    icon>
                    <v-badge
                        color="error"
                        overlap>
                        <template slot="badge">4</template>
                        <v-icon color="white">mdi-bell</v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <v-card>
                <v-list dense>
                    <v-list-item>
                        <v-list-item-title>
                            Notificari in curs de constructie
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="oneSignalEnabled" @click="requestOnesignalNotifications">
                        <template v-if="!oneSignalNotificationsAreActive">
                            <v-list-item-icon>
                                <v-icon color="error">mdi-close-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                Notificarile nu sunt activate pe acest device. Click aici.
                            </v-list-item-title>
                        </template>
                        <template v-else>
                            <v-list-item-icon>
                                <v-icon color="success">mdi-check-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                Notificarile sunt activate
                            </v-list-item-title>
                        </template>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
        -->
        <v-menu
            v-if="getAvailableWorkstations.length > 1"
            bottom
            left
            offset-y
            transition="slide-y-transition">
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    dark
                    icon>
                    <v-badge
                        color="error"
                        overlap>
                        <template slot="badge">{{ getAvailableWorkstations.length }}</template>
                        <v-icon color="white">mdi-database</v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <v-card>
                <v-list dense>
                    <v-list-item v-for="(workstation, index) in getAvailableWorkstations"
                                 :key="index"
                                 :color="workstation.id === getWorkstation.id ? 'primary' : undefined"
                                 :disabled="workstation.id === getWorkstation.id"
                                 @click="triggerChangeWorkstation(workstation)"
                    >
                        <v-list-item-title>
                            {{ workstation.name }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
        <v-btn
            dark
            icon
            @click="$router.push({name: 'auth-logout'})">
            <v-icon>power_settings_new</v-icon>
        </v-btn>
        <v-btn
            dark
            icon
            @click="refresh">
            <v-icon>refresh</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    const authMapState = createNamespacedHelpers("auth").mapState;
    const companyMapGetters = createNamespacedHelpers("workstation").mapGetters;
    const companyMapMutations = createNamespacedHelpers("workstation").mapMutations;
    import ACL from "Mixins/acl";
    export default {
        mixins: [ACL],
        data () {
            return {
                oneSignalNotificationsAreActive: false
            }
        },
        computed: {
            ...authMapState({
                isAuthenticated: "isAuthenticated"
            }),
            ...companyMapGetters({
                getAvailableWorkstations: "getAvailableWorkstations",
                getWorkstation: "getWorkstation"
            }),
            oneSignalEnabled() {
                return window.OneSignal !== undefined
            }
        },
        mounted() {
            this.checkOneSignal()
        },
        methods: {
            ...companyMapMutations({
                changeWorkstation: 'changeWorkstation'
            }),
            toggleDrawer() {
                Bus.$emit("toggleDrawer");
            },
            async refresh() {
                try {
                    window.localStorage.removeItem('app')
                }catch(e){}
                await this.$store.dispatch("auth/fetchMe")
                window.location.reload();
            },
            async triggerChangeWorkstation(workstation) {
                await this.changeWorkstation(workstation)
                window.location.reload()
            },
            async checkOneSignal() {
                let that = this
                if (window.OneSignal !== undefined) {
                    this.getOnesignalNotificationsStatus().then((isEnabled) => {
                        that.oneSignalNotificationsAreActive = isEnabled
                    })
                } else {
                    this.oneSignalNotificationsAreActive = false
                }
            }
        }
    };
</script>

<style>
</style>
